import { AfterViewInit, Component, ElementRef, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { ToTreePipe } from '../../../../../../pipe/to-tree.pipe';
import { NgIf, DatePipe } from '@angular/common';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: true,
    imports: [NgIf, DatePipe, TranslateModule, ToTreePipe]
})
export class PageHeaderComponent implements AfterViewInit {
    @Input() total!: number;
    @Input() active: boolean = true;
    @Input() startDate!: Date;
    @Input() endDate!: Date;
    @Input() isSubscribed!: Date;
    @Output() subMe = new EventEmitter()

    @ViewChild('devices') devices: ElementRef<HTMLDivElement>;
    @ViewChild('forestVideo') forestVideo: ElementRef;
    bodyEl: HTMLBodyElement;

    constructor(public responsiveScreenService: ResponsiveScreenService, public translateService: LanguageService) { }

    ngAfterViewInit(): void {
        this.updateDevicesSizeAndPosition();
        this.initResizeEvent();
        this.initVideo();
    }

    private initVideo(): void {
        if (this.forestVideo.nativeElement.paused) {
            this.forestVideo.nativeElement.inline = true;
            this.forestVideo.nativeElement.muted = true;
            this.forestVideo.nativeElement.playinline = true;
            this.forestVideo.nativeElement.autoplay = true;

            this.forestVideo.nativeElement.play();
        }
    }

    private initResizeEvent(): void {
        window.addEventListener('resize', () => {
            this.updateDevicesSizeAndPosition();
        });
    }

    private updateDevicesSizeAndPosition(): void {
        if (!this.devices?.nativeElement) { return; }
        if (window.innerWidth < this.responsiveScreenService.breakpoints['HD-s'].max) { return; }
        if (!this.bodyEl) {
            this.bodyEl = document.getElementsByTagName('body')[0];
        }
        let pageZoom = parseFloat(this.bodyEl.style.getPropertyValue('--zoom'));
        if (!pageZoom) { pageZoom = 1; }

        const windowWidth = window.innerWidth;
        const refWidth = 881 * pageZoom;
        const contentWidthWithoutDevices = 1019 * pageZoom;
        const devicesWidth = Math.min(windowWidth - contentWidthWithoutDevices, refWidth);

        const ratio = devicesWidth / refWidth;
        const bottomRef = -80 * pageZoom;
        const bottom = Math.max(bottomRef * ratio, bottomRef);

        this.devices.nativeElement.style.setProperty('--computed-bottom', bottom + 'px');
        this.devices.nativeElement.style.setProperty('--computed-width', devicesWidth + 'px');
    }
}
